module.exports = __webpack_public_path__ + "assets/img/clock.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/svg/clock.svg
// module id = 1978
// module chunks = 0